import React from 'react'
import { Link } from 'react-router-dom'
import { FaRegUserCircle } from 'react-icons/fa';
import { AiTwotoneTag } from 'react-icons/ai'


function Navbar() {
  return (
    <header>
      <div className='logo--container'>
        <div className='logo'>
          <h3 className='logo--text'>
            BPC
          </h3>
        </div>

        <p className='logo--small-text'>
          Design Studio
        </p>
      </div>

      <nav className='middle--nav'>
        <Link to='/' className='links'>Home</Link>
        <Link to='/work' className='links'>Our Work</Link>
        <Link to='/services' className='links'>Services</Link>
        <Link to='/packages' className='links'>Packages</Link>
        <Link to='/contact' className='links'>Contact</Link>

      </nav>

      <nav className='right--nav'>
        <div className='sign--btn'>
          <FaRegUserCircle className='user--icon' /> <Link to='/contact' className='sign--link'>Sign In</Link>
        </div>
        <div className='price--btn'>
          <AiTwotoneTag className='price--icon' /><Link to='/packages' className='price--link'>Pricing</Link>
        </div>
      </nav>

    </header>
  )
}

export default Navbar